/* ============================================================
   Icono de candado · Boton Finalizar Pedido · Rebuy Smart Cart
   Getmore · 12.07.26

   Inyecta un SVG de candado como primer hijo del boton de
   checkout de Rebuy. Se reinyecta en cada render/evento porque
   Rebuy reconstruye su DOM al actualizar el carrito.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR_BUTTON = '[data-rebuy-component="checkout-area"] .rebuy-cart__checkout-button';
  var LOCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M7 10V7a5 5 0 0 1 10 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/>' +
    '</svg>';

  function inject() {
    var buttons = document.querySelectorAll(SELECTOR_BUTTON);
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.querySelector('.tc-checkout-lock-icon')) return;
      var icon = document.createElement('span');
      icon.className = 'tc-checkout-lock-icon';
      icon.innerHTML = LOCK_SVG;
      btn.insertBefore(icon, btn.firstChild);
    });
  }

  function schedule() {
    if (schedule._t) clearTimeout(schedule._t);
    schedule._t = setTimeout(inject, 100);
  }

  [
    'rebuy:cart.ready',
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show'
  ].forEach(function (evt) {
    document.addEventListener(evt, schedule);
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.target && m.target.closest && m.target.closest('#rebuy-cart')) { schedule(); return; }
      for (var n = 0; n < m.addedNodes.length; n++) {
        var node = m.addedNodes[n];
        if (node.nodeType === 1 && (node.id === 'rebuy-cart' || (node.querySelector && node.querySelector('#rebuy-cart')))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    schedule();
  } else {
    document.addEventListener('DOMContentLoaded', schedule);
  }
})();
